import React, { useState } from 'react';
import { Divider, Flex, HStack, Tab, TabList, Tabs } from '@chakra-ui/react';
import StandardModal from './StandardModal';
import { useTokens } from '../../../context/TokenProvider';
const ModalWithSidebar = ({ children, tabTitles, verifyOnBlur, resetTabOnClose = true, onClose, selectedTab = 0, onTabChange, ...rest }) => {
    const tokens = useTokens();
    const [selectedIndex, setSelectedIndex] = useState(selectedTab);
    const handleTabChange = (newIndex) => {
        if (!verifyOnBlur) {
            setSelectedIndex(newIndex);
            onTabChange?.();
            return;
        }
        verifyOnBlur(() => {
            setSelectedIndex(newIndex);
            onTabChange?.();
        });
    };
    const checkTabReset = () => {
        if (resetTabOnClose) {
            setSelectedIndex(0);
        }
    };
    const handleClose = () => {
        if (!verifyOnBlur) {
            checkTabReset();
            onClose();
        }
        else {
            verifyOnBlur(() => {
                checkTabReset();
                onClose();
            });
        }
    };
    return (React.createElement(StandardModal, { isFullWidth: true, variant: "primary-large", onClose: handleClose, ...rest },
        React.createElement(HStack, { px: tokens.Spacing07, pt: tokens.Spacing08, pb: tokens.Spacing02 },
            React.createElement(Tabs, { orientation: "vertical", variant: "sidebar", index: selectedIndex, onChange: handleTabChange, isLazy: true, w: "100%" },
                React.createElement(Flex, { gap: tokens.Spacing04, w: "100%" },
                    React.createElement(TabList, { gap: tokens.Spacing03, w: "180px", minW: "180px" }, tabTitles.map((tab) => (React.createElement(Tab, { "data-testid": "modal_with_sidebar__tab", key: tab }, tab)))),
                    React.createElement(Divider, { variant: "grey", orientation: "vertical" }),
                    children)))));
};
export default ModalWithSidebar;
